<template>
    <div class="download-content">
        <!-- 套餐下载 -->
        <template v-if="activeTab === 'packageDown'">
            <packageDown
                :item="versionData"
                :type="curTabVersion"
                :active-tab="activeTab"
                @recordUserDownload="recordUserDownload"
                @containerDeployValidate="containerDeployValidate">
            </packageDown>
        </template>
        <!-- 版本列表 -->
        <template v-else>
            <versionList
                :item="versionData"
                :type="curTabVersion"
                @recordUserDownload="recordUserDownload"
                @containerDeployValidate="containerDeployValidate">
            </versionList>
        </template>
    </div>
</template>

<script>
import packageDown from './packageDown.vue'
import versionList from './versionList.vue'
export default {
    name: 'downloadContent',
    components: {
        packageDown,
        versionList
    },
    props: {
        activeTab: String,
        loading: Boolean,
        item: Object
    },
    data () {
        return {
            curTabVersion: 'containerize',
            versionData: {
                title: {},
                basic: {}, // 基础套餐
                combos: []
            }
        }
    },
    watch: {
        item: {
            handler (val) {
                this.setVersionData(val)
            },
            deep: true
        },
        activeTab () {
            this.setVersionData(this.item)
        },
    },
    methods: {
        recordUserDownload (cur) {
            this.$emit('recordUserDownload', cur)
        },
        containerDeployValidate (cur) {
            this.$emit('containerDeployValidate', cur)
        },
        setVersionData (item) {
            this.clearInfo()
            if (!item || !Array.isArray(item.children)) return
            const versionData = item.children.find(v => v.name === '容器化版本')
            if (!versionData || !Array.isArray(versionData.children)) return
            versionData.children.forEach(v => {
                if (v.name === '套餐所属版本') {
                    v.cname = v.name + '：'+ v.extra_info.version.split(' ')[0]
                    v.version = ' ' + v.extra_info.version.split(' ')[1]
                    v.release = v.extra_info.release
                    this.versionData.title = v
                } else if (v.name === '基础套餐') {
                    v.size = v.extra_info.size
                    v.md5 = v.extra_info.md5
                    this.versionData.basic = v
                } else {
                    this.versionData.combos.push(v)
                }
            })
        },
        clearInfo () {
            this.versionData.title = {}
            this.versionData.basic = {}
            this.versionData.combos = []
        }
    }
}
</script>

<style lang="scss" scoped>
.download-content {
    width: 1200px;
    margin: 0 auto;
    .package-down,
    .version-list {
        margin-top: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// downloadContent.vue?0403a81f